const empty = {
  presence: {
    allowEmpty: false,
    message: 'require'
  }
}
const Constraints = {
  countryId: empty,
  // nationality: empty
}

module.exports = {
  Constraints
}